import { ReactNode } from "react";

import { dateHandler } from "./dateHandler";

import { IPost } from "api/services/posts/types";

export const managePostsCell = (v: string | number, r: IPost, gradeHandler: (grade: number) => ReactNode) => (v && v === r.grade && typeof v === 'number') || (!v && v === 0) ? gradeHandler(v): typeof v === 'number' && v % 1 === 0 && v !== r.grade ? dateHandler(v) : v;
